/**
 * Testimonials.jsx — placeholder quote grid.
 * Firm will replace with real testimonials once collected.
 */
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const quotes = [
    {
        quote: "Their care with our GST filings has been remarkable. Every notice was handled before we even worried about it.",
        author: "Head Accountant",
        role:   "Government Department · Assam",
    },
    {
        quote: "Handling my Japanese salary and Indian property returns felt effortless with them. Truly a partner across two systems.",
        author: "NRI Client",
        role:   "Tokyo, Japan",
    },
    {
        quote: "Seventeen years of consistency is rare. They know our books better than we do — and they never take that trust lightly.",
        author: "Founding Director",
        role:   "Family Business · Dibrugarh",
    },
    {
        quote: "Migrating our books to their process felt like moving into a home someone had already tidied for us.",
        author: "CFO",
        role:   "Non-profit · Meghalaya",
    },
    {
        quote: "Their advisory during our incorporation kept us out of at least three compliance traps. Priceless.",
        author: "Managing Partner",
        role:   "Consulting Firm · Guwahati",
    },
    {
        quote: "Communication is fast, files are always ready. That is the whole review.",
        author: "NRI Client",
        role:   "Muscat, Oman",
    },
];

export default function Testimonials() {
    return (
        <div className="font-outfit" data-testid="marketing-testimonials">
            {/* HERO */}
            <section className="max-w-7xl mx-auto px-6 lg:px-10 pt-16 md:pt-24 pb-14">
                <div className="text-[10px] font-semibold tracking-[0.28em] uppercase text-[#C5A059] mb-5">
                    In our clients&apos; words
                </div>
                <h1 className="font-serif text-5xl md:text-6xl lg:text-[5rem] font-light tracking-tighter leading-[1.02] text-[#0A1128] max-w-4xl">
                    Witnesses<br />
                    <span className="italic">to their victories.</span>
                </h1>
                <p className="mt-6 text-sm text-[#0A1128]/50 italic max-w-xl">
                    Placeholder text below — real client stories will replace these entries.
                </p>
            </section>

            {/* QUOTE GRID */}
            <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-24">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {quotes.map((q, i) => (
                        <div
                            key={i}
                            data-testid={`testimonial-${i}`}
                            className="bg-[#FDFBF7] border border-[#0A1128]/10 p-8 hover:border-[#C5A059] hover:-translate-y-1 transition-all duration-300 flex flex-col"
                        >
                            <div className="font-serif text-6xl leading-none text-[#C5A059]">&ldquo;</div>
                            <blockquote className="font-serif italic text-xl lg:text-2xl font-light leading-snug text-[#0A1128] mt-2 flex-1">
                                {q.quote}
                            </blockquote>
                            <div className="mt-6 pt-4 border-t border-[#0A1128]/10">
                                <div className="text-sm font-medium text-[#0A1128]">{q.author}</div>
                                <div className="text-[11px] uppercase tracking-[0.2em] font-semibold text-[#C5A059] mt-1">
                                    {q.role}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* CTA */}
            <section className="bg-[#0A1128] text-[#FAF3E0] py-20 md:py-24">
                <div className="max-w-4xl mx-auto px-6 lg:px-10 text-center">
                    <h2 className="font-serif text-4xl lg:text-5xl font-light tracking-tight leading-tight">
                        Add your story next.
                    </h2>
                    <Link
                        to="/contact"
                        data-testid="testimonials-cta-contact"
                        className="mt-8 inline-flex items-center gap-2 bg-[#C5A059] text-[#0A1128] px-8 py-4 text-[13px] uppercase tracking-[0.2em] font-semibold hover:bg-[#FAF3E0] transition-colors duration-300"
                    >
                        Start the conversation <ArrowUpRight size={16} />
                    </Link>
                </div>
            </section>
        </div>
    );
}
